import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async update(id: Id, data: ApiRequests['api.v1.monthly-scope-gap-forecasts.update']) {
    return await api(route('api.v1.monthly-scope-gap-forecasts.update', id), 'patch', {
      data,
    });
  },

  async destroy(id: Id) {
    return await api(route('api.v1.monthly-scope-gap-forecasts.destroy', id), 'delete');
  },

  async sort(id: Id, data: ApiRequests['api.v1.monthly-scope-gap-forecasts.sort']) {
    return await api(route('api.v1.monthly-scope-gap-forecasts.sort', id), 'patch', {
      data,
    });
  },
};
